import React from 'react';
import { ReactReduxContextValue } from 'react-redux';
import { AnyAction } from 'redux';

const ReduxContext = React.createContext({} as ReactReduxContextValue<unknown, AnyAction>);
export { ReduxContext };
